import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ALLERGENS_QUERY } from '../graphql/queries'
import { COMMON_FETCH_ALLERGENS } from '../redux/action-types'
import { cleanupCommonFetchAllergens } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useAllergensQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchAllergens)

  const { isLoading, error, data, options } = useSelector(
    store => store.common.allergens,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        ALLERGENS_QUERY,
        {},
        dispatch,
        COMMON_FETCH_ALLERGENS,
      ),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useAllergensQuery
